import { observer } from "mobx-react";
import * as React from "react";
import { ImageNodeStore } from "../../../stores";
import { ResizableNodeView } from "../ResizableNodeView";
import { TopBar } from "../TopBar";
import "./../NodeView.scss";
import "./ImageNodeView.scss";

interface ImageNodeProps {
    store: ImageNodeStore;
}

/**
 * This class represents the view for an image node.
 * It extends ResizableNodeView to support interactive resizing
 * while displaying image content sourced from the node store.
 */
@observer
export class ImageNodeView extends ResizableNodeView<ImageNodeStore> {

    /**
     * This getter method returns the CSS class name for the image node.
     * @returns Class name for the image node container.
     */
    protected getNodeClassName(): string {
        return "imageNode";
    }

    /**
     * This method renders the visual content of the image node, 
     * including the top bar.
     * @returns Node representing the image node content
     */
    protected renderContent(): React.ReactNode {
        const store = this.props.store;

        return (
            <>
                <TopBar store={store} />
                <div className="content image-content">
                    <img src={store.url} alt={store.title} />
                </div>
            </>
        );
    }
}